import React, { useEffect, useState } from "react";

// Recursive component to display a discussion and its replies
function DiscussionItem({ discussion, onReply }) {
  const [showReplyForm, setShowReplyForm] = useState(false);
  const [replyContent, setReplyContent] = useState("");

  const handleReplySubmit = (e) => {
    e.preventDefault();
    if (replyContent.trim()) {
      onReply(discussion.id, replyContent);
      setReplyContent("");
      setShowReplyForm(false);
    }
  };

  return (
    <div>
      {/* Show title only for top-level discussions */}
      {discussion.title && <h1>{discussion.title}</h1>}
      <p>{discussion.content.substring(0, 128) + "..."}</p>
      <small>{new Date(discussion.created_at).toLocaleString()}</small>
      <small>{discussion.fullname}</small>
      <hr />
      {/* <button onClick={() => setShowReplyForm(!showReplyForm)}>
        {showReplyForm ? "Cancel Reply" : "Reply"}
      </button>
      {showReplyForm && (
        <form onSubmit={handleReplySubmit} style={{ marginTop: "10px" }}>
          <textarea
            value={replyContent}
            onChange={(e) => setReplyContent(e.target.value)}
            placeholder="Your reply"
            rows="3"
            style={{ width: "100%" }}
          />
          <button type="submit">Submit Reply</button>
        </form>
      )} */}
      {/* Recursively render replies if available */}
      {discussion.replies &&
        discussion.replies.length > 0 &&
        discussion.replies.map((reply) => (
          <DiscussionItem key={reply.id} discussion={reply} onReply={onReply} />
        ))}
    </div>
  );
}

export default DiscussionItem;
